<template>
    <div class="lint-one-element">
        <loader v-if="isSubmitLoading" style="z-index:10000" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
        <vsud-alert
            v-if="isSubmitted"
            icon="fa fa-bell"
            :dismissible="true"
            :color="alertColor">
            {{ alertMessage }}
        </vsud-alert>
        <div class="card mb-4">
            <div class="card-header pb-0">
                <div class="row">
                <div class="col-md-8 d-flex align-items-center">
                    <h6>{{ title }}</h6>
                </div>
                <div class="col-md-4 text-end">
                    <router-link :to="{ name: 'Local Governments' }">
                        Close <i class="fas fa-times-circle text-secondary text-lg" data-bs-toggle="tooltip" data-bs-placement="top" title="" aria-hidden="true" data-bs-original-title="Cancel" aria-label="Cancel"></i><span class="sr-only">Cancel</span>
                    </router-link>
                </div>
                </div>
            </div>
            <div class="card-body p-4">
                <div class="users-data" v-if="isLoading==false && message==''">
                    <form @submit.prevent="submitForm">
                        <div class="row">
                            <div class="col-md-8">
                                <label>Name <span class="text-danger">*</span></label>
                                <div>
                                    <input type="text" name="name" class="form-control" placeholder="Please enter name"  v-model="name" required>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label>Short name<span class="text-danger">*</span></label>
                                <div>
                                    <input type="text" name="shortname" class="form-control" placeholder="Please enter shortname"  v-model="shortname" required>
                                </div>
                            </div>
                            <div class="col-md-4 mt-3">
                                <label>
                                    States <span class="text-danger">*</span>
                                    &nbsp;
                                    <vsud-spinner-small v-if="isStateLoading"></vsud-spinner-small>
                                </label>
                                <select name="role" class="form-control" v-model="state_id"  required>
                                <option value="" :selected="true">... Select </option>
                                <option 
                                    v-for="item in states"
                                    :value="item.id" 
                                    :key="item.id">
                                    {{item.name}}
                                </option>
                                </select>
                            </div>
                            <div class="col-md-4 mt-3">
                                <label>Longitude<span class="text-danger"></span></label>
                                <div>
                                    <input type="text" name="gps_lon" class="form-control" placeholder="Please enter longitude"  v-model="gps_lon">
                                </div>
                            </div>
                            <div class="col-md-4 mt-3">
                                <label>Latitude<span class="text-danger"></span></label>
                                <div>
                                    <input type="text" name="gps_lat" class="form-control" placeholder="Please enter name"  v-model="gps_lat">
                                </div>
                            </div>
                            <div class="col-md-12 mt-4 geep-text-right">
                                <vsud-button color="success" variant="gradient"> Submit </vsud-button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="spinner-holder" v-else-if="isLoading==true && message==''">
                    <vsud-spinner></vsud-spinner>
                </div>
                <div class="nodata-data" v-else>
                    <vsud-nodata :message="message"></vsud-nodata>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import VsudButton from "@/components/VsudButton.vue";
import VsudAlert from "@/components/VsudAlert.vue";
import VsudSpinner from "@/components/VsudSpinner.vue";
import VsudSpinnerSmall from "@/components/VsudSpinnerSmall.vue";
import VsudNodata from "@/components/VsudNodata.vue";
import AuthService from '@/services/auth.service.js';
import ErrorHandler from '@/helpers/errorHandlers.js';

export default {
  name: "Local Government-form",

  props : 
  {
      itemId : {
          type : String,
          default : '',
      },
      subTitle : {
          type : String,
          default : 'Add Local Government'
      },
      formType :{
          type : String,
          default : 'Add'
      }
  },

  data()
  {
     return {
         id : this.itemId,
         title : this.subTitle,
         name : '',
         shortname : '',
         state_id : '',
         states : [],
         gps_lon : '',
         gps_lat : '',
         isLoading : false,
         isSubmitted : false,
         isSubmitLoading : false,
         isStateLoading : false,
         message : '',
         alertMessage : "",
         alertColor : 'success',
         type : this.formType
     }
  },

  components : 
  {
      VsudButton,
      VsudSpinner,
      VsudNodata,
      VsudAlert,
      VsudSpinnerSmall,
  },

  created()
  {
      this.getLocalGovernmentDetils();
      this.States();
  },

  methods : 
  {
     async States()
     {
         this.isStateLoading = true;

         try
         {
            const response = await AuthService.getStates('?perPage=37');
            this.states = response.data
            this.isStateLoading = false;
         }
         catch(error)
         {
             console.log(error);
             this.isStateLoading = false;
         }
     },

     async getLocalGovernmentDetils()
      {

        if(this.id!=''&&this.type=='Edit')
        {
            this.isLoading = true;

            try
            {
                const response = await AuthService.getSingleLocalGovernment(this.id);
                console.log(response);
                this.name = response.data.name;
                this.state_id = response.data.stateId;
                this.shortname = response.data.shortname;
                this.gps_lon = (response.data.gpslocation!=null) ? response.data.gpslocation.longitude : '';
                this.gps_lat = (response.data.gpslocation!=null) ? response.data.gpslocation.latitude : '';
                this.isLoading = false;
            }
            catch(error)
            {
                console.log(error);
                this.isLoading = false;
                this.message = error.message
            }
        }
     },

     async addLocalGovernmentAction()
     { 
         this.isSubmitLoading = true;

         try
         {
            const data = this.formDetails();

            const response = await AuthService.addLocalGovernment(data);
            const alertToken = response.data.id;
            this.$store.dispatch('setAlertToken', alertToken);

            this.isSubmitLoading = false;
            this.$router.push("/local-governments/back/"+alertToken);

         }
         catch(error)
         {
             this.errorHandler(error);
         }
     },

     async updateLocalGovernmentAction()
     {
        this.isSubmitLoading = true;

        try
        {
            const data = this.formDetails();
            const response = await AuthService.updateLocalGovernment(this.id,data);

            if(response.data.id==this.id)
            {
                this.isSubmitLoading = false;
                this.isSubmitted = true;
                this.alertMessage = 'Local Government updated successfully';
                this.alertColor = 'success';
            }
        }
        catch(error)
        {
            this.errorHandler(error);
        }
     },

    submitForm()
    {
         if(this.type=='Add')
         {
             this.addLocalGovernmentAction();
         }
         else if(this.type=='Edit')
         {
             this.updateLocalGovernmentAction();
         }
    },

    formDetails()
    {
        return {
                name : this.name,
                shortname : this.shortname,
                state_id : this.state_id,
                gps_location : [
                    {
                        longitude : this.gps_lon,
                        latitude  : this.gps_lat
                    }
                ]
        }
    },

    errorHandler(error)
    {
        this.isSubmitLoading = false;
        this.isSubmitted = true;
        this.alertColor = "danger";
        console.log(error);
        // Handle Error Message
        this.alertMessage = ErrorHandler.catchError(error);
    }

  }
};
</script>
